import { completeSilentRenewInParent, isSilentRenewFrame } from "./utils/auth/silent-renew-frame.util";

// The hidden silent-renew iframe only hands its sign-in response back to the parent tab. It must
// never boot the app: see isSilentRenewFrame.
if (isSilentRenewFrame()) {
  void completeSilentRenewInParent();
} else {
  import("./bootstrap");
}
